import { ReactNode, useEffect } from 'react';

import { LoadingPage } from '@foradevelopment/fora-ui';
import { ThunkRequestStatus } from '@fora-monorepo/webapp-types';
import { HelpPageNamesEmployerMyPages } from '@fora-monorepo/employer-my-pages-common/types';

import { EmployerMyPagesErrorPage } from '..';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getHelpPageContent } from '../../redux/content/contentThunks';

export const HelpPageDataFetcher = ({
  children,
  pageName,
}: {
  children: ReactNode;
  pageName: HelpPageNamesEmployerMyPages;
}) => {
  const dispatch = useAppDispatch();

  const content = useAppSelector(state => state.content.help.content[pageName]);
  const loadingHelpPage = useAppSelector(state => state.content.help.loadingContent);
  const thunkError = useAppSelector(state => state.error.thunkError);

  useEffect(() => {
    if (!content) dispatch(getHelpPageContent({ page: pageName }));
  }, [dispatch, pageName, content]);

  if (loadingHelpPage === ThunkRequestStatus.Fulfilled) {
    return children;
  }
  if (loadingHelpPage === ThunkRequestStatus.Rejected) {
    return <EmployerMyPagesErrorPage type={thunkError?.code} technicalError={thunkError?.message} />;
  } else {
    return <LoadingPage />;
  }
};
